import React, { useCallback } from 'react';
import {
  MainDiv,
  NewProjectSection,
  TitleSection,
  Title,
  Subtitle,
  OptionSection,
  OptionCard,
  OptionCardTitle,
  Icon,
  DescriptionSection,
  OptionCardDescription,
  OuterDiv
} from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes/urls';
import { useMobileDevice } from '../../../global/useMobile';
import ResponsiveHeader from '../../../component/responsiveHeader';
import { rootStore } from '../../../mobx/rootStore';
import { ICON_SIZE } from '../../../global/constants';

const OptionCardData = [
  {
    title: 'Blank Project',
    description: 'Start from scratch',
    icon: 'plus-icon'
  },
  {
    title: 'Use a template',
    description: 'Choose from library',
    icon: 'template-icon'
  }
  // {
  //   title: 'Import Spreadsheet',
  //   description: 'Coming soon',
  //   icon: 'spreadsheet-icon'
  // }
];

function CreateProjectStep1() {
  const history = useHistory();
  const isMobile = useMobileDevice();

  const onClickOptionCard = useCallback(
    (title: string) => {
      if (title === 'Blank Project') {
        history.push(ROUTES.CREATE_PROJECT_STEP2);
        rootStore.projectStore.createProjectInput.setTemplateId(null);
        rootStore.projectStore.createProjectInput.setSelectedTemplate(null);
      } else if (title === 'Use a template') {
        history.push(`${ROUTES.CREATE_PROJECT_STEP2}?select-template`);
      }
    },
    [history]
  );

  const renderOptionCard = useCallback(() => {
    return OptionCardData.map((item) => {
      return (
        <OptionCard
          role='button'
          onClick={() => onClickOptionCard(item.title)}
          className={item.title !== 'Import Spreadsheet' ? 'active' : ''}
          comingSoon={item.description === 'Coming soon'}>
          <Icon className={item.title === 'Blank Project' ? 'blank-project' : ''}>
            <SVGIcon
              name={item.icon}
              width='36'
              height='36'
              viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
              fill='var(--text-secondary)'
            />
          </Icon>
          <DescriptionSection comingSoon={item.description === 'Coming soon'}>
            <OptionCardTitle>{item.title}</OptionCardTitle>
            <OptionCardDescription comingSoon={item.description === 'Coming soon'}>
              {item.description}
            </OptionCardDescription>
          </DescriptionSection>
        </OptionCard>
      );
    });
  }, [onClickOptionCard]);

  const renderCloseIcon = useCallback(() => {
    return (
      <Icon role='button' className='close-Icon' onClick={() => history.goBack()}>
        <SVGIcon
          name='new-close-icon'
          width={ICON_SIZE.XL}
          height={ICON_SIZE.XL}
          viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
          fill='var(--text-secondary)'
        />
      </Icon>
    );
  }, [history]);

  return (
    <div className='desktop-app-file-view-wrapper'>
      <OuterDiv className='desktop-app-file-view'>
        {isMobile ? (
          <ResponsiveHeader title='Create New Project' noMargin={true} leftElement={renderCloseIcon()} />
        ) : (
          renderCloseIcon()
        )}
        <MainDiv>
          <NewProjectSection>
            <TitleSection>
              {!isMobile && <Title>Create New Project</Title>}
              <Subtitle>How would you like to start?</Subtitle>
            </TitleSection>
            <OptionSection>{renderOptionCard()}</OptionSection>
          </NewProjectSection>
        </MainDiv>
      </OuterDiv>
    </div>
  );
}

export default CreateProjectStep1;
